function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "profile_svg__a"
}, React.createElement("path", {
  d: "M3 2h14v16H3zm0 0"
})), React.createElement("clipPath", {
  id: "profile_svg__b"
}, React.createElement("path", {
  d: "M16.09 17.273a.725.725 0 01-.727.727.725.725 0 01-.726-.727 5.09 5.09 0 00-5.09-5.09 5.091 5.091 0 00-5.094 5.09.725.725 0 01-.726.727.725.725 0 01-.727-.727 6.545 6.545 0 1113.09 0zM9.547 10c-2.211 0-4-1.79-4-4s1.789-4 4-4a4 4 0 010 8zm0-1.453A2.544 2.544 0 0012.09 6 2.544 2.544 0 107 6a2.547 2.547 0 002.547 2.547zm0 0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#profile_svg__a)"
}, React.createElement("g", {
  clipPath: "url(#profile_svg__b)"
}, React.createElement("path", {
  fill: "#2d2d2d",
  d: "M0 0h20v20H0z"
})));

var SvgProfile = function SvgProfile(props) {
  return React.createElement("svg", _extends({
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
};

export default SvgProfile;